import { SchoolService, BaseService } from "@/services/school.service";

const ActivityService = {
    getAll() {
        return SchoolService.getAll("activities")
    },

    add(payload) {
        return SchoolService.create("activities", payload)
    },

    update(object) {
        return SchoolService.update("activities", object.identifier, object)
    },

    delete(object) {
        return SchoolService.delete("activities", object.identifier, null)
    },

    // pupils

    getPupils(object) {
        return SchoolService.getAll("activities/" + object.identifier + "/pupils")
    },

    deletePupil(result, object) {
        return SchoolService.delete("activities/" + result.identifier + "/pupils", object.identifier, null)
    },

    addPupil(payload) {
        return SchoolService.create("activities/pupils", payload)
    },

    // evidences

    getEvidences(object) {
        return SchoolService.getAll("activities/" + object.identifier + "/evidences")
    },

    deleteEvidence(result, object) {
        return SchoolService.delete("activities/" + result.identifier + "/evidences", object.identifier, null)
    },

    addEvidence(payload) {
        return SchoolService.create("activities/evidences", payload)
    },

    // attendances

    getAttendances(object) {
        return SchoolService.getAll("activities/" + object.identifier + "/attendances")
    },

    processAttendance(result, payload) {
        return SchoolService.create("activities/" + result.identifier + "/attendances", payload)
    },

}

export { ActivityService };